import React, { PureComponent } from 'react';

import Modal from '../Modal/Modal.component';

import iconInfo from '../../assets/info.svg';
import iconClose from '../../assets/close.svg';

import config from './CreditCardInput.config';
import { separateNumber, reformatNumber, capitalizeWord } from '../utils';
import iconMasterCard from './assets/mastercard_rounded.svg';
import iconVisa from './assets/visa_rounded.svg';

import './CreditCardInput.less';

class CreditCardInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      icon: iconClose,
      cardValid: false,
      modal: false,
      isFocus: false,
      currentValue: '',
      prevValue: '',
    };
  }

  static getDerivedStateFromProps(prevProps, prevState) {
    if (prevState.currentValue === '' && prevProps.input.value) {
      return {
        currentValue: separateNumber(
          prevProps.input.value,
          prevProps.limit.max,
        ),
      };
    }
    return null;
  }

  _validateCard = cardNum => {
    const len = cardNum.length;
    const parity = len % 2;
    let sum = 0;
    for (let i = len - 1; i >= 0; i -= 1) {
      let d = parseInt(cardNum.charAt(i), 10);
      if (i % 2 === parity) {
        d *= 2;
      }
      if (d > 9) {
        d -= 9;
      }
      sum += d;
    }
    return sum % 10 === 0;
  };

  _getCardType = cardNum => {
    let payCardType = null;
    const regexMap = [
      { regEx: /^4[0-9]{5}/gi, cardType: 'VISA' },
      { regEx: /^5[1-5][0-9]{4}/gi, cardType: 'MASTERCARD' },
    ];

    // Do Maping For Regex
    for (let j = 0; j < regexMap.length; j += 1) {
      if (cardNum.match(regexMap[j].regEx)) {
        payCardType = regexMap[j].cardType;
        break;
      }
    }

    return payCardType;
  };

  _forceUpdateState = value => {
    this.setState({
      currentValue: separateNumber(value, this.props.limit.max),
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.input.value !== this.props.input.value) {
      this._forceUpdateState(this.props.input.value);
    }
  }

  _onChange = event => {
    event.persist();
    const {
      input: { value },
    } = this.props;

    const caretStart = event.target.selectionStart;
    const caretEnd = event.target.selectionEnd;

    const inputValue = event.target.value.replace(/\D/g, '');
    const formatedValue = separateNumber(inputValue, this.props.limit.max);

    // Check Valid Input
    const finalCCValue = event.target.validity.valid ? formatedValue : value;

    // Check CC Validation When Input Full Fill
    if (formatedValue.length >= 19) {
      // SET CARD
      const validateCard = this._validateCard(finalCCValue.replace(/\s/g, ''));
      const getCardType = this._getCardType(finalCCValue.replace(/\s/g, ''));
      const setCard = {
        icon: iconClose,
        cardValid: validateCard,
      };

      if (validateCard) {
        switch (getCardType) {
          case 'VISA':
            setCard.icon = iconVisa;
            break;
          case 'MASTERCARD':
            setCard.icon = iconMasterCard;
            break;
          default:
            setCard.icon = iconClose;
            setCard.cardValid = false;
            break;
        }
      }

      this.setState(setCard);
    }

    if (formatedValue.length < 19) {
      this.setState({
        icon: iconClose,
        cardValid: false,
      });
    }

    this.setState(
      prevState => ({
        currentValue: formatedValue,
        prevValue: prevState.currentValue,
      }),
      () => {
        const { prevValue, currentValue } = this.state;

        if (caretStart === 0 && prevValue.length > currentValue.length) {
          event.target.setSelectionRange(0, 0);
        } else if (
          caretStart % 5 === 0 &&
          prevValue.length > currentValue.length
        ) {
          event.target.setSelectionRange(caretStart - 1, caretEnd - 1);
        } else if (caretStart % 5 === 0) {
          event.target.setSelectionRange(caretStart + 1, caretEnd + 1);
        } else {
          event.target.setSelectionRange(caretStart, caretEnd);
        }
        this.props.input.onChange(reformatNumber(formatedValue));
      },
    );
  };

  _onDismiss = () => {
    document.getElementById('inputCustomerNumber').blur();
    if (this.state.isFocus) {
      this.props.input.onChange('');
      this.setState({
        currentValue: '',
      });
    }
  };

  _changeModalVisibility = isVisible => () => {
    this.setState({
      modal: isVisible,
    });
  };

  _onFocus = () => {
    this.setState({ isFocus: true });
  };

  _onBlur = () => {
    this.setState({ isFocus: false });
  };

  render() {
    const { isFocus, icon, cardValid } = this.state;
    const {
      helper,
      input: { value },
      label,
      hint,
      intl: { formatMessage },
      placeholder,
      withHelper,
      limit,
      meta: { error, touched, pristine },
      withSeparator,
    } = this.props;

    let errorMsg = '';
    let inputState = '';
    if ((touched && error) || (!pristine && error)) {
      inputState = 'error';
      errorMsg = formatMessage(
        { id: error },
        {
          target: capitalizeWord(label),
          min: limit.min,
          max: limit.max,
        },
      );
    } else if (this.state.isFocus) {
      inputState = 'active';
    }

    const showHelper = typeof withHelper === 'boolean' && withHelper;
    const separatorLength =
      limit.max % 4 === 0
        ? parseInt(limit.max / 4, 10) - 1
        : parseInt(limit.max / 4, 10);
    const maxLength = limit.max + separatorLength;

    return (
      <>
        <div
          className="CreditCardInput"
          style={{
            borderBottom: withSeparator ? '0.6rem solid #f5f5f5' : 'none',
          }}
        >
          <div className="input-label">
            <span id="text_labelCustomerNumber">{label}</span>
          </div>
          <div className="input-row">
            <div className={`input-box ${inputState}`}>
              <input
                id="inputCustomerNumber"
                type="text"
                value={this.state.currentValue}
                autoComplete="off"
                placeholder={placeholder}
                inputMode="tel"
                pattern="[0-9 ]+"
                maxLength={maxLength}
                onFocus={this._onFocus}
                onBlur={this._onBlur}
                onChange={this._onChange}
              />
              {cardValid ? (
                <div className="icon-status show">
                  <img src={icon} alt="CardIcon" />
                </div>
              ) : (
                <button
                  type="button"
                  id="btn_closeCustomerNumber"
                  className={`icon-status ${
                    isFocus && value.length >= 1 ? 'show' : ''
                  }`}
                  onMouseDown={this._onDismiss}
                >
                  <img src={icon} alt="Status" />
                </button>
              )}
            </div>

            {showHelper && (
              <div
                id="btn_infoCustomerNumber"
                className="icon-info"
                onClick={this._changeModalVisibility(true)}
              >
                <img src={iconInfo} alt="Help" />
              </div>
            )}
          </div>

          <div className="input-hint">
            <span id="text_hintCustomerNumber" className={`show ${inputState}`}>
              {inputState === 'error' ? errorMsg : hint}
            </span>
          </div>
        </div>
        {showHelper && (
          <Modal
            visible={this.state.modal}
            onClose={this._changeModalVisibility(false)}
            {...helper}
          />
        )}
      </>
    );
  }
}

CreditCardInput.propTypes = config.propTypes;
CreditCardInput.defaultProps = config.defaultProps;
CreditCardInput.componentDetail = config.componentDetail;
CreditCardInput.builderConfig = config.builderConfig;

export default CreditCardInput;
